import api from "./axios";

/**
 * Authentication API service
 * Handles all authentication-related operations
 */
export const authApi = {
  // User login
  login: async (credentials) => {
    try {
      const response = await api.post("/auth/login", credentials);
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  // Send Or Resend Reset Password Request
  sendResetPasswordRequest: async (id) => {
    try {
      const response = await api.post(
        `/auth/send-reset-password-request/${id}`
      );
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  // Reset password
  resetPassword: async (resetData) => {
    try {
      const response = await api.post("/auth/reset-password", resetData);
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  // Request password reset
  requestForgotPassword: async (email) => {
    try {
      const response = await api.post(`/auth/forgot-password/${email}`);
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  // Resend Verification Email
  resendVerificationEmail: async (id) => {
    try {
      const response = await api.post(`/auth/resend-verification-email/${id}`);
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  //consumer-reset-password
  consumerResetPassword: async (resetData) => {
    try {
      const response = await api.post(
        "/ConsumerTwoFactor/reset-password",
        resetData
      );
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  // Logout
  logout: async () => {
    try {
      const response = await api.post("/auth/logout");
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  // Proxy login - Super Admin impersonates another user
  proxyLogin: async (proxyData) => {
    try {
      const response = await api.post("/auth/proxy-login", proxyData);
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },

  // Exit proxy session
  exitProxy: async (exitData) => {
    try {
      const response = await api.post("/auth/exit-proxy", exitData);
      return response.data;
    } catch (error) {
      return { error: getAuthErrorMessage(error) };
    }
  },
};

/**
 * Get a user-friendly error message from the API error response
 * @param {Error} error - The error object from axios
 * @returns {string} - User-friendly error message
 */
const getAuthErrorMessage = (error) => {
  if (error.response?.data?.message) {
    return error.response.data.message;
  }

  if (error.response?.data?.errors) {
    // Handle validation errors
    const errors = error.response.data.errors;
    const firstError = Object.values(errors)[0];
    return Array.isArray(firstError) ? firstError[0] : firstError;
  }

  switch (error.response?.status) {
    case 400:
      return "Invalid request. Please check your input.";
    case 401:
      return "Invalid email or password.";
    case 403:
      return "Access denied.";
    case 404:
      return "Service not found.";
    case 429:
      return "Too many requests. Please try again later.";
    case 500:
      return "Server error. Please try again later.";
    default:
      return error.message || "An unexpected error occurred.";
  }
};
